import { translationNavigation_da_part1 } from "./translationNavigation.da.part1";
import { defineTranslationTree } from "./translationTypes";
import { translationNavigation_da_part2 } from "./translationNavigation.da.part2";
import { translationNavigation_da_part3 } from "./translationNavigation.da.part3";

export const translationNavigation_da = defineTranslationTree({
  ...translationNavigation_da_part1,
  ...translationNavigation_da_part2,
  ...translationNavigation_da_part3,
});
